import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/Services-css/CleanerCards.css";
import { FaPhoneAlt, FaShieldAlt } from "react-icons/fa";

const cleaners = [
  {
    name: "Guna",
    location: "Tindivanam",
    rating: 4.8,
    reviews: 309,
    latestReview: "Second job  has done and just as good. Highly recommended",
    badges: ["identity", "phone"],
    image: "https://via.placeholder.com/64",
  },
  {
    name: "Muthu",
    location: "Tambaram",
    rating: 4.6,
    reviews: 10,
    latestReview: "Recommend  friendly.",
    badges: ["identity", "phone"],
    image: "https://via.placeholder.com/64",
  },
  {
    name: "Ganesha",
    location: "Viluppuram",
    rating: 4.8,
    reviews: 240,
    latestReview: "Thanks for a wonderful clean ✨✨",
    badges: ["phone"],
    image: "https://via.placeholder.com/64",
  },
  {
    name: "Senthil",
    location: "OMR Road",
    rating: 4.6,
    reviews: 229,
    latestReview: "The lovely guy did a good job",
    badges: ["identity", "phone"],
    image: "https://via.placeholder.com/64",
  },
];

const BadgeIcon = ({ type }) => {
  const badgeMap = {
    identity: {
      icon: <FaShieldAlt className="badge-icon" title="ID Verified" />,
      label: "ID Verified",
    },
    phone: {
      icon: <FaPhoneAlt className="badge-icon" title="Phone Verified" />,
      label: "Phone Verified",
    },
  };
  return badgeMap[type]?.icon || null;
};

export default function CleanerCards() {
  const location = useLocation();
  const navigate = useNavigate();
  const cartItems = location.state?.cartItems || [];

  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleProceed = () => {
    if (selectedIndex === null) {
      alert("Please select a cleaner before proceeding.");
      return;
    }
    const selectedCleaner = cleaners[selectedIndex];
    navigate("/slot-booking", {
      state: {
        cartItems,
        cleaner: selectedCleaner,
      },
    });
  };

  return (
    <section className="cleaner-cards-section">
      <h2 className="section-title">Choose a Professional Cleaner</h2>

      <div className="cleaner-cards-grid">
        {cleaners.map((cleaner, index) => (
          <div
            key={index}
            className={`cleaner-card ${selectedIndex === index ? "selected" : ""}`}
            onClick={() => setSelectedIndex(index)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter") setSelectedIndex(index);
            }}
          >
            <div className="cleaner-header">
              <img src={cleaner.image} alt={`Cleaner ${cleaner.name}`} className="cleaner-image" />
              <div className="cleaner-details">
                <h3 className="cleaner-name">{cleaner.name}</h3>
                <p className="cleaner-location">{cleaner.location}</p>
                <p className="cleaner-rating">⭐ {cleaner.rating} ({cleaner.reviews})</p>
              </div>
            </div>

            <div className="cleaner-review">
              <h4>Latest Review</h4>
              <p className="review-text">"{cleaner.latestReview}"</p>
            </div>

            <div className="cleaner-badges">
              <span>Verified Badges:</span>
              <div className="badge-icons">
                {cleaner.badges.map((badge, i) => (
                  <BadgeIcon key={i} type={badge} />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="proceed-wrapper">
        <button className="proceed-button" onClick={handleProceed}>
          Proceed to Book Slot
        </button>
      </div>
    </section>
  );
}
